module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHJlY3QgeD0iOTYiIHk9IjQ4IiB3aWR0aD0iMzIwIiBoZWlnaHQ9IjQxNiIgcng9IjQ4IiByeT0iNDgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMyIi8+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzMiIgZD0iTTE3NiAxMjhoMTYwTTE3NiAyMDhoMTYwTTE3NiAyODhoODAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reader-outline.svg
// module id = q868
// module chunks = 1